import { render, staticRenderFns } from "./InvoiceItems.vue?vue&type=template&id=be7f9b6e&scoped=true"
import script from "./InvoiceItems.vue?vue&type=script&lang=js"
export * from "./InvoiceItems.vue?vue&type=script&lang=js"
import style0 from "./InvoiceItems.vue?vue&type=style&index=0&id=be7f9b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7f9b6e",
  null
  
)

export default component.exports